<template>
  <form action="/api/placement_contact/update" method="POST" class="card h-100 live-form" data-model="placement.placement_contacts" :data-model_id="placement_contact.id">
    <div class="card-header">
      <div class="row">
        <div class="col d-flex align-items-center justify-content-center">
          <h4 class="m-0 placement-contact-title">{{placement_contact.placement_contact_type.name}}</h4>
        </div>
        <div class="d-flex align-items-center flex-column pl-0 pr-2">
          <div>
            <button v-tooltip="contact_tooltip" v-if="!placement.archived" type="button" class="btn-empty-white popup-trigger" data-type='contact_type_select' data-trigger='open'>
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <div>
            <button v-tooltip="contact_remove_tooltip" type="button" v-if="!placement.archived" class="btn-empty-white"
              @click="confirmDelete()">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-show="loading" class="overlay-loader">
        <div class="popup-spinner"><div></div><div></div><div></div><div></div></div>
      </div>
      <div class="form-row" v-if="!contact_id">
        <div class="col-11">
          <div class="form-group">
            <v-layout-select label="Contact" :options="contact_list" :model.sync="contact_id" classes="contact-list live-skip" :disabled="!placement_valid"></v-layout-select>
          </div>
        </div>
        <div class="col-1 align-items-start">
          <button @click="showAddNewContactPopup(placement_contact.placement_contact_type, placement_contact.id)" class="btn btn-secondary" type="button" :disabled="!placement_valid">
            <span><i class="fas fa-plus"></i></span>
          </button>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <span v-if="placement_contact.contact_data.name" v-html="placement_contact.contact_data.name" class="d-none is-textfield"></span>
            <v-layout-text label="Contact Name" :model.sync="placement_contact.contact_data.name" name="contact[name]" :readonly="!updateAdjusterContact"></v-layout-text>
            <a class="view-link" v-if="placement_contact && placement_contact.contact_id" :href="'/crm/contact/' + placement_contact.contact_id">View selected contact</a>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Title" name="contact[position]" :model.sync="placement_contact.contact_data.position"
            :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="E-mail" name="contact[email]" :model.sync="placement_contact.contact_data.email"
            :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-phone label="Cell" name="contact[phone]" :model.sync="placement_contact.contact_data.phone" :disabled="new_contact"></v-layout-phone>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <v-layout-phone label="Direct Office Phone" name="contact[office]" :model.sync="placement_contact.contact_data.office" :disabled="new_contact"></v-layout-phone>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Office Ext" name="contact[office_ext]" :model.sync="placement_contact.contact_data.office_ext"
            :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Address" name="contact[address][address]" :model.sync="placement_contact.contact_data.address.address" :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="City" name="contact[address][city]" :model.sync="placement_contact.contact_data.address.city" :disabled="new_contact"></v-layout-text>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <v-layout-select label="State" name="contact[address][state_id]" :model.sync="placement_contact.contact_data.address.state_id" :disabled="new_contact" :options="states_abbr"></v-layout-select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Zip" name="contact[address][zip]" :model.sync="placement_contact.contact_data.address.zip" :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col align-items-start">
          <div class="form-group">
            <v-layout-textarea :rows="1" label="Personal Identifier" name="contact[personal_identifier]" :model.sync="placement_contact.contact_data.personal_identifier" :disabled="new_contact"></v-layout-textarea>
          </div>
        </div>
        <div class="col align-items-start">
          <div class="form-group">
            <v-layout-textarea :rows="1" label="Personal Guidelines" name="contact[personal_guidelines]" :model.sync="placement_contact.contact_data.personal_guidelines" :disabled="new_contact"></v-layout-textarea>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col align-items-start">
          <div class="form-group">
            <v-layout-textarea :rows="1" label="Invoicing Preferences" name="contact[invoicing_preferences]" :model.sync="placement_contact.contact_data.invoicing_preferences" :disabled="new_contact"></v-layout-textarea>
          </div>
        </div>
        <div class="col align-items-start">
          <div class="form-group">
            <v-layout-textarea :rows="1" label="Personal Negotiated Fees" name="contact[negotiated_fees]" :model.sync="placement_contact.contact_data.negotiated_fees" :disabled="new_contact"></v-layout-textarea>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="placement_contact.placement_contact_type_id == 3">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="License Number" name="contact[license_number]" :model.sync="placement_contact.contact_data.license_number" :disabled="new_contact"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div :class="{ 'col-11': updateAdjusterContact, 'col': !updateAdjusterContact }">
          <div class="form-group">
            <v-layout-select :label="placement_contact.placement_contact_type.id == 1 ? 'Insurance Company' : 'Public Adjuster Company'" :options="getCompanies" :model.sync="company_id" :tags="false" classes="company-list live-skip" :disabled="!updateAdjusterContact"></v-layout-select>
            <a class="view-link" v-if="company_id" :href="'/crm/company/' + company_id">View selected company</a>
          </div>
        </div>

        <div class="col-1 align-items-start" v-if="updateAdjusterContact">
          <button @click="showAddNewCompanyPopup(placement_contact.placement_contact_type)" class="btn btn-secondary" type="button">
            <span><i class="fas fa-plus"></i></span>
          </button>
        </div>
      </div>

      <div class="form-row">
        <div class="col col-md-4">
          <div class="form-group">
            <v-layout-select label="Manager Name" name="contact[manager_id]" :model.sync="placement_contact.contact_data.manager_id" :options_url="optionsUrl" :tags="false" :disabled="new_contact"></v-layout-select>
          </div>
        </div>
        <div class="col col-md-4">
          <div class="form-group">
            <v-layout-phone label="Manager Phone" :model.sync="managerPhone" :disabled="true"></v-layout-phone>
          </div>
        </div>
        <div class="col col-md-4 align-items-start">
          <div class="form-group">
            <v-layout-text label="Manager Email" :model.sync="managerEmail" :disabled="true"></v-layout-text>
          </div>
          <button v-tooltip="'Clear Manager'" @click="clearManager(placement_contact.id)" class="btn btn-secondary ml-1" type="button" :v-if="!new_contact">
            <span><i class="fas fa-times"></i></span>
          </button>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Hub E-mail" name="company[email]" :model.sync="company_data.email" :disabled="true" :readonly="true"></v-layout-text>
          </div>
        </div>
      </div>

      <div class="form-row" v-if="showFeeFields">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Company Negotiated Fees" classes="live-skip" name="company[negotiated_fees]" :model.sync="company_data.negotiated_fees" :readonly="true"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Company Guidelines" classes="live-skip" name="company[guidelines]" :model.sync="company_data.guidelines" :readonly="true"></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="showFeeFields">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Fees Paid out of" classes="live-skip" :model.sync="housing_fee_type_id" :disabled="true" :readonly="true"></v-layout-text>
            <v-hidden v-model="company_data.housing_fee_type_id" classes="live-skip" name="company[housing_fee_type_id]"></v-hidden>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="showFeeFields">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Carrier will pay TPS Housing direct" :model.sync="pays_directly" :disabled="true" :readonly="true"></v-layout-text>
            <v-hidden v-model="company_data.pays_directly" classes="live-skip" name="company[pays_directly]"></v-hidden>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="showFeeFields">
        <div class="col">
          <div class="form-group">
            <v-layout-text label="Pays Electronically" classes="live-skip" :model.sync="pays_electronically" :disabled="true" :readonly="true"></v-layout-text>
            <v-hidden v-model="company_data.pays_electronically" classes="live-skip" name="company[pays_electronically]"></v-hidden>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-select label="TPS Sales Rep" name="contact[sales_rep_id]" :model.sync="placement_contact.contact_data.sales_rep_id" :options="users" :tags="false" :disabled="new_contact"></v-layout-select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-select label="TPS Housing Coordinator" name="contact[housing_coordinator_id]" :model.sync="placement_contact.contact_data.housing_coordinator_id" :options="users" :tags="false" :disabled="new_contact"></v-layout-select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <v-layout-select label="TPS Status Coordinator" name="contact[status_coordinator_id]" :model.sync="placement_contact.contact_data.status_coordinator_id" :options="users" :tags="false" :disabled="new_contact"></v-layout-select>
          </div>
        </div>
      </div>
      <!-- <div class="form-row">
        <div class="col">
          <div class="form-group">
          <label>Contact History</label>
          <v-select class="form-control"
          :options="contact_history[placement_contact.placement_contact_type.id]">
          </v-select>
          <small id="" class="form-text text-danger">Value is invalid</small>
          </div>
        </div>
      </div> -->
      <v-hidden v-model="placement_contact.id" name="id"></v-hidden>
      <v-hidden v-model="placement_contact.contact.id" name="contact_id"></v-hidden>
      <v-hidden v-model="index" name="order"></v-hidden>
      <v-hidden v-model="placement_contact.company.id" name="company_id"></v-hidden>
      <v-hidden v-model="placement_contact.company.approved" name="company[approved]"></v-hidden>
      <v-hidden v-model="placement.id" name="placement_id"></v-hidden>
      <v-hidden v-model="placement_contact.placement_contact_type.id" name="placement_contact_type_id"></v-hidden>
    </div>
    <div class='card-footer card-footer-border'>
    </div>
  </form>
</template>

<script>
export default {
  props: ['placement', 'placement_contact', 'placement_contact_index', 'pi', 'placement_valid', 'company_data'],
  data() {
    return {
      contact_id: this.placement_contact.contact.id,
      company_id: this.placement_contact.company.id,
      skip_contact_watch: false,
      skip_company_watch: false,
      contact_list_addition: [],
      company_list_addition: [],
      loading: false,
      updateAdjusterContact: false,
    }
  },
  methods: {
    optionsUrl() {
      return '/api/contact/list?add_new=true&company_id=' + this.company_id + '&except_id=' + this.contact_id;
    },
    clearManager () {
      this.placement_contact.contact_data.manager_id = '';

      if (this.placement_contact.contact_data.manager) {
        this.placement_contact.contact_data.manager.phone = '';
        this.placement_contact.contact_data.manager.email = '';
      }

      $(this.$el).find('select[name="contact[manager_id]"]').append('<option value=""></option>').val('').trigger('change');
    },
    confirmDelete () {
      const hasSelected = !!this.contact_id;

      Swal.fire({
        title: 'Do you want to delete or update this information?',
        heightAuto: false,
        showConfirmButton: hasSelected,
        showCloseButton: true,
        showCancelButton: true,
        showDenyButton: hasSelected,
        width: 700,
        confirmButtonText: 'Adjuster Change',
        cancelButtonText: 'Delete From Placement',
        cancelButtonColor: '#ff1d25',
        denyButtonText: 'Update Adjuster Contact',
        denyButtonColor: '#2778c4'
      }).then((result) => {
        if (result.dismiss === 'cancel') {
          // Delete From Placement
          this.$root.clone_remove('/api/placement_contact/delete', this.placement_contact, this.placement.placement_contacts, (this.placement_contact_index + (this.pi * 4)))
        } else if (result.isConfirmed) {
            // Adjuster Change
          let $this = this;
          this.updateAdjusterContact = false;

          $this.skip_contact_watch = true;
          $this.placement_contact.contact.id = null;
          $this.placement_contact.company.id = null;
          $this.contact_id = null;
          $this.company_id = null;
          $this.placement_contact.contact_data = {};
          $this.placement_contact.contact = {};
          $this.placement_contact.company_data = {};
          $this.placement_contact.company = {};

          let placement_contact = _.cloneDeep($this.$root.models.placement_contact);
          $this.$root.placement.placement_contacts[$this.placement_contact_index].company_data = placement_contact.company_data;
          $this.$root.placement.placement_contacts[$this.placement_contact_index].contact_data = placement_contact.contact_data;
          $this.$root.placement.placement_contacts[$this.placement_contact_index].company = placement_contact.company;
          $this.$root.placement.placement_contacts[$this.placement_contact_index].contact = placement_contact.contact;
          
          $($this.$el).find('[name="contact[sales_rep_id]"]').empty();
          $($this.$el).find('[name="contact[housing_coordinator_id]"]').empty();
          $($this.$el).find('[name="contact[status_coordinator_id]"]').empty();
          $($this.$el).find('[name="contact[manager_id]"]').empty();

          $($this.$el).find('[name="contact[sales_rep_id]"]').append('<option value=""></option>').val('');
          $($this.$el).find('[name="contact[housing_coordinator_id]"]').append('<option value=""></option>').val('');
          $($this.$el).find('[name="contact[status_coordinator_id]"]').append('<option value=""></option>').val('');
          $($this.$el).find('[name="contact[manager_id]"]').append('<option value=""></option>').val('');
        } else if (result.isDenied) {
          // Update Adjuster Contact
          this.updateAdjusterContact = true;
        }
      })
    },
    showAddNewContactPopup (type, placement_contact_id, is_manager = false) {
      popup_open('editor-contact_editor', { popup_id: parseInt(this.placement_contact.id) });
      let popup = $('.popup[data-type="editor-contact_editor"]');
      popup.find('button[data-type="discard"]').click();
      popup.find('input[name="type_id"]').val(type.id).trigger('update');
      popup.find('input[name="type_name"]').val(type.name);
      if (is_manager) {
        window.app_data.contact.company_contacts[0].company_id = this.placement_contact.company_data.id;
        popup.find('select[name="company_contacts[0][company_id]"]').trigger('update');
      } else {
        popup.find('input[name="placement_contact_id"]').val(placement_contact_id);
      }

      window.app_data.adding_manager = is_manager;

      const contactCompanyTypes = {
        'Carrier Adjuster': 'Insurance Company',
        'Public Adjuster': 'Public Adjuster Company',
        'Independent Adjuster': 'Independent Adjuster Company',
      };
      const companyType = this.$root.options.company_types.find(company_type => company_type.text === (contactCompanyTypes[type.name] || 'Other'));
      window.app_data.active_placement_contact_type = { ...companyType };

      if (popup.find('form [name="placement_id"]').length) {
        popup.find('form [name="placement_id"]').val(this.placement.id);
      } else {
        popup.find('form').append('<input type="hidden" name="placement_id" value="' + this.placement.id + '" />');
      }

      if (type.id == 4) {
        popup.find('input[name="other_type_info"]').closest('.col').show();
        popup.find('select[name="sales_rep_id"]').closest('.col').hide();
        popup.find('select[name="housing_coordinator_id"]').closest('.col').hide();
        popup.find('select[name="status_coordinator_id"]').closest('.col').hide();
      } else {
        popup.find('input[name="other_type_info"]').closest('.col').hide();
        popup.find('select[name="sales_rep_id"]').closest('.col').show();
        popup.find('select[name="housing_coordinator_id"]').closest('.col').show();
        popup.find('select[name="status_coordinator_id"]').closest('.col').show();
      }

      if (type.id == 3) {
        popup.find('input[name="license_number"]').closest('.col').show();
      } else {
        popup.find('input[name="license_number"]').closest('.col').hide();
      }
    },
    showAddNewCompanyPopup (type) {
      popup_open('editor-company_editor', { popup_id: parseInt(this.placement_contact.id) });
      let popup = $('.popup[data-type="editor-company_editor"]');

      if (type && type.name) {
        switch (type.name) {
          case 'Carrier Adjuster':
            window.app_data.company.company_type_id = 1;
            break;
          case 'Public Adjuster':
            window.app_data.company.company_type_id = 2;
            break;
          case 'Independent Adjuster':
            window.app_data.company.company_type_id = 3;
            break;
          default:
            window.app_data.company.company_type_id = 4;
            break;
        }

        popup.find('select[name="company_type_id"]').closest('.col').hide();
      }
    }
  },
  beforeDestroy () {
    $(window).off("/api/placement_contact/update.success.placement_contact"+this.placement_contact.id);
    $(window).off("/api/placement_contact/update.error.placement_contact"+this.placement_contact.id);
    $(window).off('/api/contact/maybe_create.success');
    $(window).off('/api/contact/maybe_create.error');
    $(window).off('/api/company/maybe_create.success');
    $(window).off('/api/company/maybe_create.error');
  },
  mounted () {
    let $this = this;

    $(window).on('/api/placement_contact/update.form-submitting.placement_contact' + $this.placement_contact.id, (e, response, form) => {
      $this.loading = true;
    });

    $(window).on('/api/placement_contact/update.success.placement_contact'+$this.placement_contact.id, (e, response, form) => {
      $this.loading = false;
      let id = _.get(response, 'updated.contact.id', '') || null;
      let company_id = _.get(response, 'updated.company.id', '') || null;

      if (($this.index) != _.get(response, 'updated.order', '')) return;

      if (typeof $this.$root.contact_list_index[id] == 'undefined' && !isNaN(id)) {
        $this.$root.options.contact_list.push({
          id: id,
          text: _.get(response, 'updated.contact.name', '')
        });
        $this.$root.contact_list_index[id] = $this.$root.options.contact_list.length - 1;
      }

      if (typeof $this.$root.companies_index[company_id] == 'undefined' && !isNaN(company_id)) {
        $this.$root.options.companies.push({
          id: company_id,
          text: _.get(response, 'updated.company.name', ''),
          type: $this.placement_contact.placement_contact_type.name
        });
        $this.$root.companies_index[company_id] = $this.$root.options.companies.length - 1;
      }

      $this.skip_contact_watch = true;
      $this.contact_id = id;
      $this.placement_contact.contact = _.get(response, 'updated.contact', '');
      $this.placement_contact.contact_data = _.get(response, 'updated.contact_data', '');

      if ($this.placement_contact.contact_data.manager) {
        $($this.$el).find('[name="contact[manager_id]"]')
          .append('<option value="' + $this.placement_contact.contact_data.manager_id + '">' + $this.placement_contact.contact_data.manager.name + '</option>')
          .val($this.placement_contact.contact_data.manager_id);
      }

      $this.skip_company_watch = true;
      if ($this.placement_contact.placement_contact_type.id == 1 && !$('.insurance-company > select').val()) {
          $this.placement.company_tbd = false;
          $this.$nextTick(() => {
              $this.placement.company_id = company_id;
              $('.insurance-company > select').trigger('update');
              $('input[name="company_tbd"]').trigger('update');
          });
      };
      $this.company_id = company_id;
      $this.placement_contact.company.id = company_id;
      $this.placement_contact.company = _.get(response, 'updated.company', '');
      $this.placement_contact.company_data = _.get(response, 'updated.company_data', '');

      $this.$nextTick(()=>{
        let form = $($this.$el).closest('form');
        let payload = eleToJSON(form, form.find('.live-form :input'));
        form.data('payload', payload);
      });
    });

    $(window).on("/api/placement_contact/update.error.placement_contact"+$this.placement_contact.id, (e, response, form)=> {
      $this.loading = false;
      message("Something went wrong. Please refresh the page.", 1);
    //   $this.placement_contact.contact.id = null;
    //   $this.placement_contact.company.id = null;
    });

    $(window).on("/api/contact/maybe_create.success", (e, response, form) => {
      let type = 'editor-contact_editor';

      if (window.app_data.adding_manager) {
        window.app_data.adding_manager = false;
        $this.placement_contact.contact_data.manager_id = response.id;
        $($this.$el).find('[name="contact[manager_id]"]')
          .append('<option value="' + response.id + '">' + response.name + '</option>')
          .val(response.id)
          .trigger('change');
        popup_close(type);
        return;
      }

      let data = response;
      let existing = $this.contact_list_addition.filter(x => x.id == data.id);
      if (!existing.length) {
        $this.contact_list_addition.push({
          id: data.id,
          text: data.name,
          type_id: data.type_id
        });
      }
      let theData = $(`.popup[data-type="${type}"]`).data('value');

      if (theData && theData.hasOwnProperty('popup_id')) {
        $(`[data-model_id="${theData.popup_id}"] .contact-list`)
          .append('<option value="' + data.id + '">' + data.name + '</option>')
          .val(data.id)
          .trigger('change');
      }

      popup_close(type);
    });

    $(window).on("/api/contact/maybe_create.error", (e, response, form) => {
      console.log('Error:', response);
    });

    $(window).on("/api/company/maybe_create.success", (e, response, form) => {
      let data = response;
      let existing = $this.company_list_addition.filter(x => x.id == data.id);
      if (!existing.length) {
        $this.company_list_addition.push({
          id: data.id,
          text: data.name,
        });
      }

      let type = 'editor-company_editor';
      let theData = $(`.popup[data-type="${type}"]`).data('value');

      if (theData && theData.hasOwnProperty('popup_id')) {
        $(`[data-model_id="${theData.popup_id}"] .company-list`)
          .append('<option value="' + data.id + '">' + data.name + '</option>')
          .val(data.id)
          .trigger('change');
      }

      popup_close('editor-company_editor');
    });

    $(window).on("/api/company/maybe_create.error", (e, response, form) => {
      console.log('Error:', response);
    });

    if ($this.placement_contact.contact_data.manager) {
      setTimeout(() => {
        $($this.$el).find('[name="contact[manager_id]"]')
          .append('<option value="' + $this.placement_contact.contact_data.manager_id + '">' + $this.placement_contact.contact_data.manager.name + '</option>')
          .val($this.placement_contact.contact_data.manager_id);
      }, 500);
    }
  },
  watch: {
    'placement_contact.contact_data.manager_id'(nv, ov) {
      if (!this.placement_valid || nv !== 'add_new') return;

      this.placement_contact.contact_data.manager_id = '';
      this.showAddNewContactPopup(this.placement_contact.placement_contact_type, this.placement_contact.id, true);
      $(this.$el).find('[name="contact[manager_id]"]')
        .append('<option value=""></option>')
        .val('')
        .trigger('change');
    },
    'placement_contact.contact_data.name' (nv, ov) {
      if (!this.placement_valid) return;
      if (nv == ov) return;

      let $this = this;

      $this.$nextTick(() => {
        if (typeof $this.$root.options.contact_list[$this.$root.contact_list_index[$this.placement_contact.contact.id]] == 'undefined') {
          $this.contact_id = null;
          return;
        }
        $this.$root.options.contact_list[$this.$root.contact_list_index[$this.placement_contact.contact.id]].text = nv;
      });
    },
    'placement_contact.company_data.name' (nv, ov) {
      if (!this.placement_valid) return;

      if (nv == ov) return;
      let $this = this;

      $this.$nextTick(() => {
        if (typeof $this.$root.options.companies[$this.$root.companies_index[$this.placement_contact.company.id]] == 'undefined') {
          $this.company_id = null;
          return;
        }
        $this.$root.options.companies[$this.$root.companies_index[$this.placement_contact.company.id]].text = nv;
      });
    },
    contact_id (nid, oid) {
      let $this = this;

      if (!$this.placement_valid) return;

      if ($this.skip_contact_watch) {
        $this.skip_contact_watch = false;
        return;
      }

      if (nid == oid || nid == null || nid=="") return;

      $this.loading = true;
      $this.placement_contact.contact.id = nid;
      $this.$nextTick(() => {
        const val = $($this.$el).find('[name="contact_id"]').val();
        $($this.$el).find('[name="contact_id"]').val('').trigger('update');
        $($this.$el).find('[name="contact_id"]').val(val).trigger('update');
      });
    },
    company_id (nid, oid) {
      if (!this.placement_valid) return;
      let $this = this;

      if ($this.skip_company_watch) {
        $this.skip_company_watch = false;
        return;
      }

      if (nid == oid || nid == null || nid=="") return;

      $this.loading = true;
      $this.placement_contact.company.id = nid;
      $this.$nextTick(()=>{
        $($this.$el).find("[name='company_id']").trigger("update");
      });

    }
  },
  computed:{
    managerPhone: {
      get () {
        if (this.placement_contact.contact_data.manager) {
          return this.placement_contact.contact_data.manager.phone;
        }

        return '';
      },
      set () {},
    },
    managerEmail: {
      get () {
        if (this.placement_contact.contact_data.manager) {
          return this.placement_contact.contact_data.manager.email;
        }

        return '';
      },
      set () {},
    },
    showFeeFields() {
      return [1, 2].includes(this.placement_contact.placement_contact_type_id);
    },
    housing_fee_type_id: {
      get () {
        const value = this.$root.options.housing_fee_types.find((i) => i.id == this.company_data.housing_fee_type_id);
        return value ? value.text : "";
      },
      set () {},
    },
    pays_directly: {
      get () {
        const value = this.$root.options.confirm_extra.find((i) => i.id == this.company_data.pays_directly);
        return value ? value.text : "";
      },
      set () {},
    },
    pays_electronically: {
      get () {
        const value = this.$root.options.confirm_extra.find((i) => i.id == this.company_data.pays_electronically);
        return value ? value.text : "";
      },
      set () {},
    },
    index: {
      get () {
        return (this.placement_contact_index+(this.pi*4));
      },
      set (value) {
        this.placement_contact.order = value;
      }
    },
    new_contact () {
      // return this.placement_contact.contact.approved_at === null
      // return false;

      if (this.placement_contact.contact.id === null || this.placement_contact.contact.id === '') {
          return true;
      }

      return false;
    },
    new_company () {
      // let is_new = !boolean(this.placement_contact.company.approved);

      // if (this.placement_contact.company.id == null||
      // this.placement_contact.company.id=="") {
      //     is_new = false;
      // }

      // return is_new;
      return false;
    },
    contact_history (){
      return this.$root.contact_history;
    },
    contact_list () {
      let a = this.$root.options.contact_list.filter(item => {
        return item.type_id == this.placement_contact.placement_contact_type.id;
      });

      return [...this.contact_list_addition, ...a];
    },
    companies () {
      let a = this.$root.options.companies;

      return [...this.company_list_addition, ...a];
    },
    states_abbr () {
      return this.$root.options.states_abbr;
    },
    sales_reps () {
      return this.$root.options.sales_reps;
    //   return [{id: null, text: "---"}, ...this.$root.options.sales_reps];
    },
    users () {
      return this.$root.options.users;
    },
    contact_tooltip () {
      return this.$root.contact_tooltip;
    },
    contact_remove_tooltip () {
      return this.$root.contact_remove_tooltip;
    },
    getCompanies () {
      const type = this.placement_contact.placement_contact_type.name;
      let companies = [];

      switch (type) {
        case 'Carrier Adjuster':
          companies = this.companies.filter(company => company.type === 'Insurance Company' || this.company_id == company.id);
          break;
        case 'Public Adjuster':
          companies = this.companies.filter(company => company.type === 'Public Adjuster Company' || this.company_id == company.id);
          break;
        case 'Independent Adjuster':
          companies = this.companies.filter(company => company.type === 'Independent Adjuster Company' || this.company_id == company.id);
          break;
        default:
          companies = this.companies.filter(company => company.type === 'Other' || this.company_id == company.id);
          break;
      }

      return companies;
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/contact-manager.vue